module.exports = {
  default: 'gathering/sidePanel',
  field: name => `gathering/sidePanel/${name}`
}
